import Menu from "@mui/material/Menu";
import {
  excerpt,
  getAssets,
  isUniCompare,
  isUniFavorite,
  upperFirstLetter,
} from "@unisearch/helpers";
import { authAtom } from "@_recoil/_state";
import dynamic from "next/dynamic";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";
import { useRecoilValue } from "recoil";
import Image from "next/legacy/image";
import styles from "./top_rank_uni_card.module.scss";
import { Alert, Snackbar } from "@mui/material";
import ChatAction from "@unisearch/common/ui_element/actions/chat_connect";
import ConversationAction from "@unisearch/common/ui_element/actions/conversation";
import { useRouter } from "next/router";

const FavoriteAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/favorite"),
  { ssr: false }
);

const CompareAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/compare"),
  { ssr: false }
);

export const TopRankUniCard = ({ data, fetchFavUniData, ...props }) => {
  const profileInfo = useRecoilValue(authAtom);
  const route = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // console.log(data);
  const link = `/study/${data?.countrySlug}/university/${data?.universitySlug}`;
  const courseLink = `/study/${data?.countrySlug}/university/${data?.universitySlug}/courses`;

  return (
    <>
      {/* dropdown start */}
      <Menu
        className={`popular_course_dropdown ${styles.popular_course_dropdown}`}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ padding: "0px" }}
      >
        <div className={styles.popular_course_dropdown_wrapper}>
          <div className={styles.dropdown_heading_wrapper}>
            <span>Popular Courses</span>
            <FiX onClick={handleClose} />
          </div>
          <div className={styles.dropdown_body_wrapper}>
            {/* <div className={styles.body_heading}>
              <span>course</span>
              <span>Action</span>
            </div> */}

            <ul>
              {data &&
                data?.popularCourse?.length > 0 &&
                data.popularCourse?.map((course, i) => {
                  return (
                    <li key={i}>
                      <div className={styles.course}>
                        <div className={styles.course_level}>
                          {course?.levelName}
                        </div>
                        <Link
                          legacyBehavior
                          href={`${link}/${course?.courseSlug}`}
                        >
                          <a className={styles.course_name}>
                            {course?.courseName}
                          </a>
                        </Link>
                      </div>

                      {/* <Link  legacyBehavior href={`${link}/${course?.courseSlug}`}>
                        <a className={styles.action_btn}>Apply Now</a>
                      </Link> */}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </Menu>
      {/* dropdown end */}

      <div className={styles.uni_rank_card}>
        <div className={styles.favorite_wrapper}>
          <FavoriteAction
            fetchFavUniData={fetchFavUniData}
            referance="university"
            referanceId={parseInt(data.universityId)}
            is_favorite={isUniFavorite(profileInfo, data.universityId)}
          />
          <CompareAction
            referance="university"
            referanceId={parseInt(data.universityId)}
            is_compared={isUniCompare(profileInfo, data.universityId)}
          />
          {(route?.pathname === "/app/student/favorite" ||
            route?.pathname === "/app/student/favorite/university") && (
            <>
              <ChatAction recieverType="university" uniId={data.universityId} />
              <ConversationAction email={data.universityMail} />
            </>
          )}
        </div>
        <div className={styles.uni_image_wrapper}>
          {/* <img
            src={
              data.featureImageSrc ||
              getAssets("assets/images/image_placeholder_big.webp")
            }
            alt="University"
          /> */}

          <Image
            layout="responsive"
            width={380}
            height={175}
            blurDataURL={getAssets(
              "assets/images/study/country_placeholder.webp"
            )}
            placeholder="blur"
            className={styles.featured_image}
            src={
              data.featureImageSrc ||
              getAssets("assets/images/image_placeholder_big.webp")
            }
            alt={data.universityName || "University Cover Photo"}
          />
        </div>

        <div className={styles.uni_card_top}>
          {data.rankFrom && parseInt(data.rankFrom) != 0 && (
            <div className={styles.uni_rank}>
              Rank: {data.rankingVarying}
              {data.rankFrom}{" "}
              {parseInt(data.rankTo) != 0 && " - " + data.rankTo}
            </div>
          )}

          <Link legacyBehavior href={link || "#"}>
            <a className={styles.uni_logo_wrapper}>
              <Image
                width={92}
                height={37}
                blurDataURL={getAssets(
                  "assets/images/uni-profile/logo-placeholder.png"
                )}
                placeholder="blur"
                src={
                  data.logoSrc ||
                  getAssets("assets/images/uni-profile/logo-placeholder.png")
                }
                alt={"University Logo"}
              />

              {/* <img src={data.logoSrc} alt="University Logo" /> */}
            </a>
          </Link>

          <Link legacyBehavior href={link || "#"}>
            <a className={styles.uni_name}>{data.universityName}</a>
          </Link>
          <p className={styles.uni_address}>
            {data.universityType ? upperFirstLetter(data.universityType) : ""}{" "}
            university, Estd {data.universityEstd}
          </p>
          <p className={styles.uni_address}>
            {data.cityName}, {data.stateName}
          </p>
        </div>

        <div className={styles.uni_card_bottom}>
          {data.totalCourse && (
            <div className={styles.uni_course_link_wrapper}>
              {data.popularCourse?.length > 0 && (
                <button
                  className={styles.btn_popular_course}
                  id="basic-button"
                  aria-controls="basic-menu"
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <FiPlus /> <span>Popular Courses</span>
                </button>
              )}

              <Link legacyBehavior href={courseLink || "#"}>
                <a className={styles.uni_course_link}>
                  View All {data.totalCourse} Courses
                </a>
              </Link>
            </div>
          )}

          {data?.overview && (
            <div className={styles.uni_desc}>
              {data?.overview ? excerpt(data.overview, 150) : ""}
            </div>
          )}

          {/* <div className={styles.uni_ranking_wrapper}>
            <div className={styles.ranking_title}>
              <BsTrophyFill />
              <span>University Ranking </span>
            </div>
            <ul>
              <li>
                <span>#33rd</span>
                <span>World University Rankings 2022</span>
              </li>
              <li>
                <span>#6th</span>
                <span>QS- World University Ranking 2022</span>
              </li>
              <li>
                <span>#1200th</span>
                <span>THE - Times Higher Education 2022</span>
              </li>
              <li>
                <span>#46th</span>
                <span> US News & World Report 2022</span>
              </li>
            </ul>
          </div> */}

          <div className={styles.footer_btn_wrapper}>
            {/* <button className={`${styles.btn_follow} btn btn-primary btn-md`}>
              <FiPlus /> <span>Follow</span>
            </button> */}

            {/* <Link  legacyBehavior href="#">
              <a className={styles.download_link}>
                <MdPictureAsPdf />
                <span>Download Brochure</span>
              </a>
            </Link> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default TopRankUniCard;
